import {
  selectCustomerPhotoUri,
  selectFullName,
  selectCustomerFirstName,
  selectCustomerIsRealEstateAgent,
} from 'src/store/selectors/customerProfile'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Avatar, Text } from 'src/Components'
import { MAX_FULL_NAME_LENGTH } from 'src/constants/listings'
import styles from './AgentCardHeader.module.scss'

const AgentCardHeader = () => {
  const customerFullName = useSelector(selectFullName) || ''
  const customerPhoto = useSelector(selectCustomerPhotoUri)
  const customerFirstName = useSelector(selectCustomerFirstName)
  const isRea = useSelector(selectCustomerIsRealEstateAgent)

  return (
    <>
      <div className={styles.header}>
        <div className={styles.name}>
          <Text
            element='div'
            size='xxs'
            variant='neutralCool'
            variantCount='600'
            weight='bold'
            transform='uppercase'
          >
            {isRea ? (
              <FormattedMessage
                id='AgentCard.realEstateAgent'
                defaultMessage='Real Estate Agent'
              />
            ) : (
              <FormattedMessage
                id='AgentCard.lendingPro'
                defaultMessage='Lending Pro'
              />
            )}
          </Text>
          <Text
            element='div'
            variant='neutralCool'
            variantCount='900'
            weight='semibold'
          >
            {customerFullName?.length > MAX_FULL_NAME_LENGTH
              ? customerFirstName
              : customerFullName}
          </Text>
        </div>
        <Avatar
          className={styles.avatar}
          src={customerPhoto}
          alt={customerFullName}
        />
      </div>
      <Text
        className={styles.subheader}
        element='div'
        size='s'
        variant='neutralCool'
        variantCount='700'
      >
        <FormattedMessage
          id='AgentCard.subCta'
          defaultMessage='Here to help you on your journey through homeownership.'
        />
      </Text>
    </>
  )
}

export default AgentCardHeader
